export default "__VITE_ASSET__B6g8Twjo__"